import {
  FETCH_REGION_REQUEST,
  FETCH_REGION_FAILURE,
  FETCH_REGION_SUCCESS
} from './actions';

export default function regionReducer(state = { id: null }, action) {
  switch (action.type) {
    case FETCH_REGION_REQUEST:
    case FETCH_REGION_FAILURE:
      return { ...state, id: null };

    case FETCH_REGION_SUCCESS:
      return { ...state, id: action.payload.result };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/region/reducer.js